export const LoginStatus = "LoginStatus";

export function changLoginStatus() {
  return { type: LoginStatus };
}